import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sidebar_alt_active",
  "use": "sidebar_alt_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sidebar_alt_active\"><path fill-rule=\"evenodd\" d=\"M0 3c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H.992A.994.994 0 0 1 0 17V3Zm7-1h1v16H7V2ZM2 8h3v1H2V8Zm0-2h3v1H2V6Zm0-2h3v1H2V4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol